import React, { Component } from 'react'
import { Link } from 'react-router'

import IconHelp from 'components/Icons/Help'
import IconMenu from 'components/Icons/Menu'
import imgLogo from 'static/images/logo-white.png'

import cn from 'classnames'
import s from './Header.scss'
import sLay from 'styles/modules/layout.scss'

export default class Header extends Component {
  render() {
    const { layout, allConfirmed, atTop } = this.props

    return (
      <div className={cn(s.outer, { [s.filled]: !atTop })}>
        <div className={cn(sLay['layout-row'], sLay['layout-align-space-between'], s.inner)}>
          <a className={s.button} onClick={() => this.props.toggleMenu()}>
            <IconMenu size={30} active={layout.menuOpen} />
          </a>

          {allConfirmed ? (
            <Link
              to="/dashboard"
              className={cn(
                s.logo,
                sLay['hide-xs'],
                sLay['layout-column'],
                sLay['layout-align-center-center']
              )}
            >
              <img alt="logo" src={imgLogo} />
            </Link>
          ) : (
            <div className={s.confirmationWarning}>
              <b>Warning!</b> You are required to have a verified email and phone number.
            </div>
          )}

          <a
            className={cn(s.button)}
            href="https://helpcentre.thinkpickle.com.au/"
            target="_blank"
            rel="noopener noreferrer"
            title="Help documentation"
          >
            <IconHelp size={28} />
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx